import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import brand from "../../images/hoop.png";
import { IoMdClose } from "react-icons/io";

const Billing = () => {
  const mobileRestrictStyles = `
.mobile-restriction-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  padding: 20px;
  box-sizing: border-box;
}

.mobile-restriction-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.mobile-restriction-icon {
  font-size: 48px;
  color: #4a6da7;
  margin-bottom: 20px;
}

.mobile-restriction-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.mobile-restriction-message {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
}

@media (min-width: 1024px) {
  .mobile-restriction-overlay {
    display: none !important;
  }
}
`;

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  // Mock data for demo purposes
  const mockClasses = [
    { id: 1, class_name: "Nursery" },
    { id: 2, class_name: "LKG" },
    { id: 3, class_name: "UKG" },
  ];

  const mockStudents = {
    Nursery: [
      {
        id: 1,
        studentId: "RM001",
        firstName: "John",
        middleName: "",
        lastName: "Doe",
      },
      {
        id: 2,
        studentId: "RM002",
        firstName: "Jane",
        middleName: "",
        lastName: "Smith",
      },
    ],
    LKG: [
      {
        id: 3,
        studentId: "RM003",
        firstName: "Mike",
        middleName: "",
        lastName: "Johnson",
      },
      {
        id: 4,
        studentId: "RM004",
        firstName: "Sarah",
        middleName: "",
        lastName: "Williams",
      },
    ],
    UKG: [
      {
        id: 5,
        studentId: "RM005",
        firstName: "David",
        middleName: "",
        lastName: "Brown",
      },
      {
        id: 6,
        studentId: "RM006",
        firstName: "Emily",
        middleName: "",
        lastName: "Davis",
      },
    ],
  };

  const mockFees = {
    RM001: [
      {
        studentId: "RM001",
        firstName: "John",
        middleName: "",
        lastName: "Doe",
        class_name: "Nursery",
        receipt_no: "RM1001",
        monthly_fee: 3000,
        tiffin: 500,
        vehicle_charge: 1000,
        others: 0,
        previous_dues: 500,
        fee_month: "Baisakh",
        status: "unpaid",
      },
    ],
    RM002: [
      {
        studentId: "RM002",
        firstName: "Jane",
        middleName: "",
        lastName: "Smith",
        class_name: "Nursery",
        receipt_no: "RM1002",
        monthly_fee: 3000,
        tiffin: 0,
        vehicle_charge: 1000,
        others: 0,
        previous_dues: 0,
        fee_month: "Baisakh",
        status: "unpaid",
      },
    ],
  };

  const [classes] = useState(mockClasses);
  const [students, setStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [feeMonth, setFeeMonth] = useState("Baisakh");
  const [fees, setFees] = useState([]);
  const [receiptNo, setReceiptNo] = useState("");
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({
    name: "",
    paidAmount: "",
    paymentMethod: "cash",
  });
  const [pdfPreview, setPdfPreview] = useState("");
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [billNo, setBillNo] = useState(675); // Starting bill number
  const [isGenerating, setIsGenerating] = useState(false);

  const resetForm = () => {
    setReceiptNo("");
    setSelectedClass("");
    setSelectedStudent("");
    setFeeMonth("Baisakh");
    setFees([]);
    setShowPaymentForm(false);
    setPdfPreview("");
    setPaymentDetails({
      name: "",
      paidAmount: "",
      paymentMethod: "cash",
    });
  };

  useEffect(() => {
    if (selectedClass) {
      // Get students from mock data
      setStudents(mockStudents[selectedClass] || []);
    }
  }, [selectedClass]);

  const handleSearch = () => {
    if (receiptNo) {
      // Simulate search by receipt number
      const foundFees = Object.values(mockFees)
        .flat()
        .filter((fee) => fee.receipt_no === receiptNo);
      setFees(foundFees);
    } else if (selectedStudent && feeMonth) {
      // Simulate search by student and month
      const studentFees = mockFees[selectedStudent] || [];
      setFees(studentFees.filter((fee) => fee.fee_month === feeMonth));
    } else {
      alert(
        "Please provide either a receipt number or select a class, student, and month."
      );
    }
  };

  const handlePayment = () => {
    if (fees.length > 0) {
      setShowPaymentForm(true);
    } else {
      alert("Please search for fee details before proceeding.");
    }
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setIsGenerating(true);

    try {
      if (
        paymentDetails.name &&
        paymentDetails.paidAmount &&
        paymentDetails.paymentMethod
      ) {
        // Simulate payment processing
        setTimeout(() => {
          generatePdfPreview();
          setBillNo((prevBillNo) => prevBillNo + 1);
          setShowPaymentForm(false);
          setIsGenerating(false);
        }, 1000);
      } else {
        alert("Please fill all payment details.");
        setIsGenerating(false);
      }
    } catch (error) {
      console.error("Error processing payment:", error);
      alert("Error processing payment");
      setIsGenerating(false);
    }
  };

  const generatePdfPreview = () => {
    // Create a container for HTML content
    const container = document.createElement("div");
    container.innerHTML = `
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>Fee Receipt</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              font-size: 2rem;
              line-height: 1.4;
              margin: 0;
              padding: 20px;
            }
              p{
              font-size:1.2rem;
              }
            .container {
               width: calc(100%-20px); /* A4 width */
            height: calc(100%-20px); /* A4 height */
            padding: 20px; /* padding inside the container */
              padding: 20px;
              box-sizing: border-box;
            }
            .header {
              text-align: center;
              margin-bottom: 50px;
            }
              .header img{
              width:200px;}
            .header h1 {
              margin: 0;
              font-size: 2rem;
            }
            .header p {
              margin: 5px 0;
            }
            .student-info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
            }
            .student-info div {
              width: 48%;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
              font-size: 1.2rem;
            }
            th,
            td {
              border: 1px solid #000;
              padding: 5px;
              text-align: left;
              
            }
            .footer {
              display: flex;
              justify-content: space-between;
              margin-top: 40px;
            }
            .school-copy {
              margin-top: 40px;
              border-top: 1px dashed #000;
              padding-top: 20px;
            }
            .twocol {
              display: flex;
              gap: 40%;
            }
            .sign{
            padding-top: 20px;
            border-top: 1px solid black;
            }
            .school-copy .footer{
            padding-top:50px;}
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <img src="${brand}" alt="Brand Logo" />
              <h1>Hoop</h1>
              <p>Email: school@email.com | Phone: 01-4450570,9843233371</p>
              <p>Address: Kageshwori Manahara, Danchhi, Kathmandu</p>
              <h2>Fee Receipt</h2>
            </div>
            <div class="student-info">
              <div>
                <p><strong>Student Name:</strong> ${fees[0].firstName} ${
      fees[0].middleName
    } ${fees[0].lastName}</p>
                <p><strong>Student ID:</strong> ${fees[0].studentId}</p>
                <p><strong>Fee For the month(s):</strong> ${
                  fees[0].fee_month
                }</p>
              </div>
              <div>
                <p><strong>Date of Payment:</strong> ${new Date().toLocaleDateString()}</p>
                <p><strong>Class:</strong> ${fees[0].class_name}</p>
                <p><strong>Receipt no:</strong> ${fees[0].receipt_no}</p>
                <p><strong>Bill no:</strong> ${billNo}</p> 
                </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Fees Description</th>
                  <th>Amount Nrs.</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Monthly Fee</td>
                  <td>Rs. ${fees[0].monthly_fee}</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Tiffin</td>
                  <td>Rs. ${fees[0].tiffin}</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Vehicle Charge</td>
                  <td>Rs. ${fees[0].vehicle_charge}</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Others</td>
                  <td>Rs. ${fees[0].others}</td>
                </tr>
                <tr>
                  <td colspan="2">Total</td>
                  <td>Rs. ${(
                    parseFloat(fees[0].monthly_fee) +
                    parseFloat(fees[0].tiffin) +
                    parseFloat(fees[0].vehicle_charge) +
                    parseFloat(fees[0].others) +
                    parseFloat(fees[0].previous_dues)
                  ).toFixed(2)}</td>
                </tr>
                <tr>
                  <td colspan="2">Paid Amount</td>
                  <td>Rs. ${paymentDetails.paidAmount}</td>
                </tr>
                <tr>
                  <td colspan="2">Balance Due</td>
                  <td>Rs. ${(
                    parseFloat(fees[0].monthly_fee) +
                    parseFloat(fees[0].tiffin) +
                    parseFloat(fees[0].vehicle_charge) +
                    parseFloat(fees[0].others) +
                    parseFloat(fees[0].previous_dues) -
                    parseFloat(paymentDetails.paidAmount)
                  ).toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
            <p><strong>Total Due Amount:</strong> Rs. ${(
              parseFloat(fees[0].monthly_fee) +
              parseFloat(fees[0].tiffin) +
              parseFloat(fees[0].vehicle_charge) +
              parseFloat(fees[0].others) +
              parseFloat(fees[0].previous_dues) -
              parseFloat(paymentDetails.paidAmount)
            ).toFixed(2)}</p>
            <p><strong>Paid Through:</strong> ${
              paymentDetails.paymentMethod
            }</p>
            <div class="footer">
              <p>Received With Thanks,</p>
              <div class="sign">
              <p>For Hoop</p>
              </div>
            </div>
            <div class="school-copy">
               <div class="header">
               <img src="${brand}" alt="Brand Logo" />
              <h1>Hoop</h1>
              <p>Email: school@email.com | Phone: 01-4450570,9843233371</p>
              <p>Address: Kageshwori Manahara, Danchhi, Kathmandu</p>
              <h2>Fee Receipt</h2>
            </div>
              <div class="twocol">
                <div class="row">
                  <p><strong>Receipt no:</strong> ${fees[0].receipt_no}</p>
                  <p><strong>Student Name:</strong> ${fees[0].firstName} ${
      fees[0].middleName
    } ${fees[0].lastName}</p>
                  <p><strong>Student ID:</strong> ${fees[0].studentId}</p>
                  <p><strong>Fee For the month(s):</strong> ${
                    fees[0].fee_month
                  }</p>
                  <p><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
                </div>
                <div class="row">
                  <p><strong>Bill no:</strong> ${billNo}</p> 
                  <p><strong>Paid By:</strong> ${paymentDetails.name}</p>
                  <p><strong>Paid Amount:</strong>Rs. ${
                    paymentDetails.paidAmount
                  }</p>
                  <p><strong>Payment Method:</strong>${
                    paymentDetails.paymentMethod
                  }</p>
                  <p><strong>Balance Due:</strong> Rs. ${(
                    parseFloat(fees[0].monthly_fee) +
                    parseFloat(fees[0].tiffin) +
                    parseFloat(fees[0].vehicle_charge) +
                    parseFloat(fees[0].others) +
                    parseFloat(fees[0].previous_dues) -
                    parseFloat(paymentDetails.paidAmount)
                  ).toFixed(2)}</p>
                </div>
              </div>
              <div class="footer">
              <p>Received With Thanks,</p>
              <div class="sign">
              <p>For Hoop</p>
              </div>
            </div>
            </div>
          </div>
        </body>
      </html>
    `;

    // Append container to the body
    document.body.appendChild(container);

    // Use html2canvas to capture the container
    html2canvas(container, { scale: 2 })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210; // A4 width in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);

        setPdfPreview(pdfUrl); // Set preview URL for display
        setShowPdfPreview(true); // Show the preview

        // Clean up the container
        document.body.removeChild(container);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        alert("Error generating PDF preview");
      });
  };

  const handleClosePreview = () => {
    setShowPdfPreview(false);
    URL.revokeObjectURL(pdfPreview);
    resetForm();
  };
  const MobileRestriction = () => (
    <div className="mobile-restriction-overlay">
      <div className="mobile-restriction-content">
        <div className="mobile-restriction-icon">💻</div>
        <h2 className="mobile-restriction-title">Desktop Required</h2>
        <p className="mobile-restriction-message">
          This application is optimized for desktop use only. Please access this
          page from a computer or laptop for the best experience.
        </p>
        <p className="mobile-restriction-message">
          <strong>Minimum screen width: 1024px</strong>
        </p>
      </div>
    </div>
  );

  return (
    <>
      {/* Add the style tag */}
      <style>{mobileRestrictStyles}</style>

      {/* Show mobile restriction overlay when on mobile */}
      {isMobile && <MobileRestriction />}

      <div className="billing-page-main fix-height">
        <div className="billing-page box">
          <h2 className="main-heading">Fee Billing Details</h2>

          <div className="search-form">
            <div className="form-group">
              <label>Receipt No:</label>
              <input
                className="form-control"
                type="text"
                value={receiptNo}
                onChange={(e) => setReceiptNo(e.target.value)}
                placeholder="Try RM1001 or RM1002"
              />
            </div>
            <p
              className="sub-heading"
              style={{ textAlign: "center", margin: "0" }}
            >
              or,
            </p>
            <div className="form-group">
              <label>Select Class:</label>
              <select
                className="form-control"
                value={selectedClass}
                onChange={(e) => setSelectedClass(e.target.value)}
              >
                <option value="">Select a class</option>
                {classes.map((classItem) => (
                  <option key={classItem.id} value={classItem.class_name}>
                    {classItem.class_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Select Student:</label>
                <select
                  className="form-control"
                  value={selectedStudent}
                  onChange={(e) => setSelectedStudent(e.target.value)}
                  disabled={!selectedClass}
                >
                  <option value="">Select a student</option>
                  {students.map((student) => (
                    <option key={student.id} value={student.studentId}>
                      {student.firstName} {student.middleName}{" "}
                      {student.lastName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Fee Month:</label>
                <input
                  className="form-control"
                  type="text"
                  value={feeMonth}
                  onChange={(e) => setFeeMonth(e.target.value)}
                  placeholder="Try 'Baisakh'"
                />
              </div>
            </div>

            <button className="badge bg-success" onClick={handleSearch}>
              Search
            </button>
          </div>

          {fees.length > 0 && (
            <div
              className="fees-table"
              style={{ marginTop: "20px", fontSize: "11px" }}
            >
              <h3 className="main-heading">Fee Details</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>Receipt No</th>
                    <th style={{ width: "20%" }}>Student Name</th>
                    <th>Monthly Fee</th>
                    <th>Tiffin</th>
                    <th>Vehicle Charge</th>
                    <th>Others</th>
                    <th>Dues</th>
                    <th>Total</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {fees.map((fee, index) => (
                    <tr key={index}>
                      <td>{fee.receipt_no}</td>
                      <td>{`${fee.firstName} ${fee.middleName} ${fee.lastName}`}</td>
                      <td>{fee.monthly_fee}</td>
                      <td>{fee.tiffin}</td>
                      <td>{fee.vehicle_charge}</td>
                      <td>{fee.others}</td>
                      <td>{parseFloat(fee.previous_dues).toFixed(2)}</td>
                      <td>
                        {(
                          parseFloat(fee.monthly_fee) +
                          parseFloat(fee.tiffin) +
                          parseFloat(fee.vehicle_charge) +
                          parseFloat(fee.others) +
                          parseFloat(fee.previous_dues)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {fee.status === "paid" ? (
                          <span className="badge paid-status">Paid</span>
                        ) : (
                          <button
                            className="badge bg-success"
                            onClick={handlePayment}
                          >
                            Pay Bill
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="pdf-info">
          {showPaymentForm ? (
            <div className="payment-section">
              <div className="overview-header">
                <h3>Payment Details</h3>
                <button className="close-btn" onClick={handleClosePreview}>
                  <IoMdClose />
                </button>
              </div>
              <form onSubmit={handlePaymentSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Paid By:</label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      value={paymentDetails.name}
                      onChange={handlePaymentChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Paid Amount:</label>
                    <input
                      className="form-control"
                      type="number"
                      name="paidAmount"
                      value={paymentDetails.paidAmount}
                      onChange={(e) => {
                        const value = Math.max(0, Number(e.target.value));
                        handlePaymentChange({
                          target: { name: "paidAmount", value },
                        });
                      }}
                      min="0"
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select
                      className="form-control"
                      name="paymentMethod"
                      value={paymentDetails.paymentMethod}
                      onChange={handlePaymentChange}
                      required
                    >
                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="qr">QR Payment</option>
                    </select>
                  </div>
                </div>

                <button type="submit" className="submit-btn">
                  Process Payment
                </button>
              </form>
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-icon">💳</div>
              <div className="empty-text">No Payment In Progress</div>
              <div className="empty-subtext">Select a bill to make payment</div>
            </div>
          )}
        </div>

        {showPdfPreview && pdfPreview && (
          <div className="pdf-preview-modal">
            <div className="modal-content">
              <button className="close-btn" onClick={handleClosePreview}>
                <IoMdClose />
              </button>
              <iframe
                src={pdfPreview}
                title="PDF Preview"
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            </div>
          </div>
        )}

        {isGenerating && (
          <div className="loading-modal-overlay">
            <div className="loading-modal">
              <div className="loading-spinner"></div>
              <p>Generating Receipt...</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Billing;
